<template>
  <main-farme>
    <div slot="aside-left">
      <!-- :DialogFlag.sync="shwoContentDialogProp" -->
      <!-- 迹点基本信息：名称、poi、主图 简介 分类、标签-->
      <el-card shadow="never"
               class="card-header-style"
               :body-style="{ padding: '15px' }"
               style="height: auto; width: 400px; border-radius: 5px">
        <div slot="header"
             class="header-product-title">
          {{formResidenceInfo.residence_name}}
        </div>
        <show-image :src="formResidenceInfo.residence_cover"
                    :image_type_name="`residence_cover_+${this.formResidenceInfo.residence_id}`"
                    @getImageURl="getImageURl"></show-image>
        <!-- <div style="height: 100px"></div> -->

        <!-- 名称 -->
        <input-modify :showEditorButtom="true"
                      :title="formResidenceInfo.residence_name"
                      @saveInputContent="renewResidenceName"></input-modify>
        <!-- 英文名称 -->
        <input-modify :showEditorButtom="true"
                      :title="formResidenceInfo.residence_en_name"
                      @saveInputContent="renewResidenceEnName"></input-modify>
        <!-- 当地名称 -->
        <input-modify :showEditorButtom="true"
                      :title="formResidenceInfo.residence_loc_name"
                      @saveInputContent="renewResidenceLocName"></input-modify>
      </el-card>
      <!-- 目的地 -->
      <el-card shadow="never"
               :body-style="{ padding: '15px' }"
               style="margin-top:10px">
        <!-- 所属目的 -->
        <div style="display:flex;">
          <!-- 只选择目的地 -->
          <select-dest :cbPath="false"
                       @selectDest="selectDest"
                       :destShowBack="formResidenceInfo.city"
                       placeholder="请选择目的地"
                       :selectInputWidth="100"></select-dest>
          <!-- 选择所在目的地 region区 -->
          <el-select size="mini"
                     style="margin-left:10px;width:100px"
                     v-model="formResidenceInfo.region"
                     filterable
                     @change="renewResidence"
                     placeholder="请选择位置">
            <el-option v-for="item in regionList"
                       :key="item.value"
                       :label="item.loc_name"
                       :value="item.loc_id"></el-option>
          </el-select>
          <!-- 类型 -->
          <el-select v-model="formResidenceInfo.residence_type"
                     size="mini"
                     style="margin-left:10px;width:100px"
                     @change="renewResidence"
                     placeholder="请选类型">
            <el-option v-for="item in typeList"
                       :key="item.value"
                       :label="item.lable"
                       :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!-- 地址、电话、打车搜索 -->
        <div style="margin-top:20px">
          <input-modify title="地址："></input-modify>
          <input-modify :showEditorButtom="true"
                        :title="formResidenceInfo.residence_address"
                        @saveInputContent="renewResidenceAddress"></input-modify>
          <el-divider></el-divider>
          <input-modify title="电话："></input-modify>
          <input-modify :showEditorButtom="true"
                        :title="formResidenceInfo.residence_taxi"
                        @saveInputContent="renewResidenceTaxi"></input-modify>
          <el-divider></el-divider>
          <input-modify title="打车搜索："></input-modify>
          <input-modify :showEditorButtom="true"
                        :title="formResidenceInfo.residence_tell"
                        @saveInputContent="renewResidenceTell"></input-modify>
        </div>

      </el-card>
      <!-- -------------------------------------地图选点------------------------------- -->
      <el-card shadow="never"
               style="margin-top: 10px;">
        <!-- 定位：选择/ 添加/ 展示 -->
        <input-modify title="关联定位"></input-modify>

        <!-- 展示 地图定位 -->
        <div style="position:relative">
          <show-location-on-map ref="showLocationOnMap"></show-location-on-map>
          <!-- 修改按钮 -->
          <el-button style="display:block;margin:0 auto;width:100%"
                     size="mini"
                     type="primary"
                     @click="openSeleceOrAddPOI">绑定定位</el-button>
        </div>
        <!-- 添加和修改 坐标的页面 -->
        <el-dialog :visible.sync="showLocationOnMap"
                   width="50%">
          <select-or-add-poi-list @submitPoi="bandNewPoi"
                                  @closeSubmitPOI="closeSubmitPOI"
                                  :proplat="lat"
                                  :proplng="lng"></select-or-add-poi-list>
        </el-dialog>

      </el-card>
      <!-- -------------------------------------更新记录--------------------------------- -->
      <el-card shadow="never"
               class="card-header-style"
               style="margin-top: 10px; width: 400px; border-radius: 5px">
        <div class="content-left-info">
          <b>更新记录：</b>
        </div>
      </el-card>
    </div>

    <!-- ------------------------------- 右侧内容 编辑区 ------------------------------- -->

    <div slot="main">
      <el-card shadow="never"
               style="margin-bottom: 20px">
        <!-- 页头 -->
        <el-page-header @back="goBack">
          <div slot="content">
            <div class="page-header-button">详情</div>
          </div>

        </el-page-header>
        <el-divider></el-divider>
        <!-- 简介/:特色 亮点 注意事项 -->
        <editor title="住处简介（特色 亮点 抵达说明 注意事项）"
                :upLoadImgAddress="`${$ip}/add_image?key_name=residenct_introduce_${this.formResidenceInfo.residence_id}`"
                :show_content="formResidenceInfo.residence_introduce"
                @save="saveResidenceInfroduce"></editor>
      </el-card>
      <!-- 酒店周边 -->
      <el-card shadow="never">
        <el-button size="mini"
                   @click="addTraverPointToResidence"
                   type="primary">修改周边推荐</el-button>
        <!-- 迹点列表 -->
        <div>
          <div class="recommand_traver_of_residence"
               v-for="item,index of recommend_traver"
               :key="index">
            <div>📍 {{item.traver_title}}{{item.traver_class}}</div>
            <div v-if="item.open_type==0">
              营业日期：
              <span v-if="item.open_value == ['1','2','3','4','5','6','7']">周一 至 周日</span>
              <span v-else-if="item.open_value == ['1','2','3']">周一 至 周三</span>
              <span v-else-if="item.open_value == ['1','2','3','4','5']">周一 至 周五</span>
              <span v-else
                    style="margin-left:5px"
                    v-for="i,index in item.open_value"
                    :key="index">
                <span v-if="i=='1'">星期一</span>
                <span v-else-if="i=='2'">星期二</span>
                <span v-else-if="i=='3'">星期三</span>
                <span v-else-if="i=='4'">星期四</span>
                <span v-else-if="i=='5'">星期五</span>
                <span v-else-if="i=='6'">星期六</span>
                <span v-else-if="i=='7'">星期日</span>
              </span>

            </div>
            <div>营业时间：{{item.open_time}}</div>
            <div v-if="item.traver_remark">提示：{{}}</div>
            <div v-html="item.traver_info"></div>
          </div>
        </div>
      </el-card>
      <!-- 选择迹点对话框 -->
      <select-and-band-traver-point ref="select_and_band_traver_point"
                                    buttonName="添加推荐"
                                    :TraverPointList='traver_point_list'
                                    :show.sync="showBandTraverPointSelect"
                                    :residence_id="formResidenceInfo.residence_id"
                                    @clickTraverPointCard="clickTraverPointCard"
                                    @searchButton="searchButton"
                                    @creatNewTraverContent="creatNewTraverContent"
                                    @loadMorTraverPointer="loadMorTraverPointer"
                                    @reNewTraverContent="reNewTraverContent">
        <div slot="map">
          <show-traver-near-residence ref='showLocationOnMap'
                                      :latprop="lat"
                                      :lngprop="lng"
                                      @clickMapTraverPoint="clickMapTraverPoint"
                                      :poiList="traver_point_list"></show-traver-near-residence>
        </div>
      </select-and-band-traver-point>
    </div>
  </main-farme>
</template>

<script>
// 组件
import MainFrame from '../../components/common/main/MainFrame'
import ShowImageAndUpLoad from '../../components/common/other/ShowImageAndUpLoad'
import ShowLocationOnMap from '../../components/map/ShowLocationOnMap'

import ShowTitleAndModify from '../../components/common/modify/ShowTitleAndModify'
import TitleAndButton from '../../components/common/modify/TitleAndButton'

import SelectAndBandTraverPointToResidence from '../../components/common/select/SelectAndBandTraverPointToResidence'
import SelectOrAddPoiList from '../../components/map/SelectOrAddPoiList'
import Editor from '../../components/common/modify/EditorV2ModifyMini'
import SelectDateType from '../../components/common/select/SelectDateType'

import CardMiniList from '../../components/common/cards/CardMiniList'
import CardListFullImage from '../../components/common/cards/CardListFullImage'
import ShowRecommendList from '../../components/common/cards/ShowRecommendList'
import DestSelect from '../../components/common/select/SelectDest'
import ShowTraverNearResidence from '../../components/map/ShowTraverNearResidence'

export default {
  name: 'residence_introduce',
  components: {
    'main-farme': MainFrame,
    'input-modify': ShowTitleAndModify,
    'title-and-button': TitleAndButton,
    ShowLocationOnMap,
    SelectOrAddPoiList,
    'show-image': ShowImageAndUpLoad,
    SelectDateType,
    Editor,
    'select-dest': DestSelect,
    'select-and-band-traver-point': SelectAndBandTraverPointToResidence,
    'card-check-list': CardMiniList,
    ShowRecommendList,
    'card-list-full-image': CardListFullImage,
    'show-traver-near-residence': ShowTraverNearResidence,
  },
  data() {
    return {
      source_map: '2',
      // 住处信息
      formResidenceInfo: {
        residence_id: null,
        residence_name: '',
        residence_en_name: '',
        residence_loc_name: '',
        residence_cover: '',
        residence_introduce: '', // 迹点介绍
        residence_type: '',
        residence_address: '',
        residence_taxi: '',
        residence_tell: '',
        city: null,
        region: '',
      },
      recommend_traver: [],
      regionList: '',
      // 住处类型
      typeList: [
        {
          lable: '酒店',
          value: 1,
        },
        {
          lable: '民宿',
          value: 2,
        },
        {
          lable: '别墅',
          value: 3,
        },
      ],
      // 坐标
      showLocationOnMap: false, // 显示修改定位
      lat: null,
      lng: null,
      // 迹点所在目的地
      traver_class: '', //  迹点分类
      traver_tag: '', // 标签

      // 关联内容
      showContentSelect: false, // 显示绑定内容
      content_guide: '', // 迹点导览
      content_group: '', //内容组
      content_media: '', //媒体
      product: '',
      // 推荐 周边迹点
      traver_point_list: [], // 服务端获取的迹点列表

      renewTraverPointSelect: false, // 修改推荐
      showBandTraverPointSelect: false, //显示选择迹点
      bandTraverList: [], // 已绑定的traverid
      key_word: '',
      page: 1,
      pagesize: 10,
    }
  },
  mounted() {
    // console.log(this.$route.query.traver_id);
    this.formResidenceInfo.residence_id = this.$route.query.residence_id
    // this.getTraverPointFromDest(this.formResidenceInfo.residence_id)
    this.getResidenceInfo()
  },
  methods: {
    selectDest(value) {
      this.formResidenceInfo.city = value
      this.$http
        .post('/traver/renew_residence_info', this.formResidenceInfo)
        .then((res) => {
          if (res.data.errno == '0') {
            this.$message({
              message: res.data.errmsg,
              type: 'success',
            })
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
      // 发送请求获得分区，发给分区选择器
      this.$http.post('/get_dest', { pid: value }).then((res) => {
        // console.log(res)
        const { data, errno } = res.data
        if (errno == '0') {
          // console.log(res)
          this.regionList = data
        }
      })
    },
    getResidenceInfo() {
      this.$http
        .get(
          `/traver/get_residence_info?residence_id=${this.formResidenceInfo.residence_id}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            // console.log(res)
            // 坐标
            // 坐标
            if (res.data.data.poi.lat !== null) {
              this.lat = parseFloat(res.data.data.poi.lat)
              this.lng = parseFloat(res.data.data.poi.lng)
              this.$refs.showLocationOnMap.lat = this.lat
              this.$refs.showLocationOnMap.lng = this.lng
              this.$refs.showLocationOnMap.pointerOnMap()
            }
            // 名字
            this.formResidenceInfo.residence_name = res.data.data.residence_name
            this.formResidenceInfo.residence_en_name =
              res.data.data.residence_en_name
            this.formResidenceInfo.residence_loc_name =
              res.data.data.residence_loc_name
            // 封面
            this.formResidenceInfo.residence_cover =
              res.data.data.residence_cover
            // 介绍
            this.formResidenceInfo.residence_introduce =
              res.data.data.residence_introduce
            // 城市
            this.formResidenceInfo.city = parseInt(res.data.data.dest_city)
            // 地区
            this.selectDest(parseInt(res.data.data.dest_city))
            this.formResidenceInfo.region = res.data.data.dest_region
            //  类型
            this.formResidenceInfo.residence_type = parseInt(
              res.data.data.residence_type
            )
            // 地址
            this.formResidenceInfo.residence_address =
              res.data.data.residence_address
            this.formResidenceInfo.residence_tell = res.data.data.residence_tell
            this.formResidenceInfo.residence_taxi = res.data.data.residence_taxi
            // 周边迹点
            this.recommend_traver = res.data.data.recommend_traver
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    }, // 返回
    goBack() {
      // this.$router.go(-1)
      this.$router.push({ name: 'residence_hub_list' })
    },
    // ----------------------------  基本信息----------------------------------------
    renewResidence() {
      // console.log(this.formResidenceInfo)
      this.$http
        .post('/traver/renew_residence_info', this.formResidenceInfo)
        .then((res) => {
          this.selectDest(res.data.data.dest_city)
          this.formResidenceInfo.city = parseInt(res.data.data.dest_city)
          this.formResidenceInfo.region = res.data.data.dest_region
          this.formResidenceInfo.residence_id = res.data.data.id
          this.formResidenceInfo.residence_address =
            res.data.data.residence_address
          this.formResidenceInfo.residence_loc_address =
            res.data.data.residence_loc_address

          this.formResidenceInfo.residence_cover = res.data.data.residence_cover
          this.formResidenceInfo.residence_en_name =
            res.data.data.residence_en_name
          this.formResidenceInfo.residence_introduce =
            res.data.data.residence_introduce
          this.formResidenceInfo.residence_loc_name =
            res.data.data.residence_loc_name
          this.formResidenceInfo.residence_name = res.data.data.residence_name
          this.formResidenceInfo.residence_type = parseInt(
            res.data.data.residence_type
          )
          // 坐标
          // console.log(res.data.data)
          if (res.data.data.poi.lat !== null) {
            this.$refs.showLocationOnMap.lat = parseFloat(res.data.data.poi.lat)
            this.$refs.showLocationOnMap.lng = parseFloat(res.data.data.poi.lng)
            this.$refs.showLocationOnMap.pointerOnMap()
          }
        })
    },
    renewResidenceName(name) {
      new Promise((resolve, reject) => {
        this.formResidenceInfo.residence_name = name
        resolve()
      }).then((res) => {
        this.renewResidence()
      })
    },
    renewResidenceEnName(name) {
      new Promise((resolve, reject) => {
        this.formResidenceInfo.residence_en_name = name
        resolve()
      }).then((res) => {
        this.renewResidence()
      })
    },
    renewResidenceLocName(name) {
      new Promise((resolve, reject) => {
        this.formResidenceInfo.residence_loc_name = name
        resolve()
      }).then((res) => {
        this.renewResidence()
      })
    },
    // 修改酒店/住处简介
    saveResidenceInfroduce(value) {
      new Promise((resolve, reject) => {
        this.formResidenceInfo.residence_introduce = value
        resolve()
      }).then((res) => {
        this.renewResidence()
      })
    },
    // 修改酒店地址
    renewResidenceAddress(address) {
      new Promise((resolve, reject) => {
        this.formResidenceInfo.residence_address = address
        resolve()
      }).then((res) => {
        this.renewResidence()
      })
    },
    // 修改酒店电话
    renewResidenceTell(tell) {
      new Promise((resolve, reject) => {
        this.formResidenceInfo.residence_tell = tell
        resolve()
      }).then((res) => {
        this.renewResidence()
      })
    },
    // 修改打车信息
    renewResidenceTaxi(taxi) {
      new Promise((resolve, reject) => {
        this.formResidenceInfo.residence_taxi = taxi
        resolve()
      }).then((res) => {
        this.renewResidence()
      })
    },
    // 修改封面图
    getImageURl(value) {
      //  修改 封面图
      this.$http
        .get(
          `/traver/change_residence_cover?residence_id=${this.formResidenceInfo.residence_id}&residence_cover=${value}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            this.formResidenceInfo.residence_cover = value
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // ----------------------------  地图坐标----------------------------------------
    // 修改迹点定位按钮
    openSeleceOrAddPOI() {
      this.showLocationOnMap = true
    },
    // 提交定位
    closeSubmitPOI() {
      this.showLocationOnMap = !this.showLocationOnMap
    },
    // 绑定坐标给酒店
    bandNewPoi(value) {
      // console.log('绑定坐标')
      this.$http
        .get(
          `/traver/band_poi_for_residence?poi_id=${value}&residence_id=${this.formResidenceInfo.residence_id}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            this.$message({
              message: res.data.errmsg,
              type: 'success',
            })
            this.showLocationOnMap = false
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })

      this.showLocationOnMap = true
      this.lat = value.lat
      this.lng = value.lng
    },
    // 点击  地图上的坐标
    clickMapTraverPoint(value) {
      console.log(value)
      // value.id,
      // value.position.lat,
      // value.position.lng
      this.$refs.showLocationOnMap.clickOnPointer(
        value.id,
        value.position.lat,
        value.position.lng
      )
      this.$refs.select_and_band_traver_point.band_Traver_list.push(value.id)
    },
    // ----------------------------  绑定迹点 ----------------------------
    // 新建 周边推荐
    creatNewTraverContent(val) {
      this.$http
        .get(
          `/traver/band_traver_to_residence?residence_id=${this.formResidenceInfo.residence_id}&traver_id_list=${val}`
        )
        .then((res) => {
          console.log(res)
          if (res.data.errno == '0') {
            this.$message({
              message: res.data.errmsg,
              type: 'success',
            })
            this.getResidenceInfo()
            this.showBandTraverPointSelect = !this.showBandTraverPointSelect
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 更新  周边推荐
    reNewTraverContent() {
      console.log('更新周边推荐', val)
    },
    // 点击卡片，地图定位到迹点
    clickTraverPointCard(traver_item) {
      // console.log('点击卡片，地图定位到迹点', traver_item)
      this.$refs.showLocationOnMap.clickOnPointer(
        traver_item.id,
        traver_item.lat,
        traver_item.lng
      )
    },
    // 打开对话框 绑定迹点给酒店
    addTraverPointToResidence() {
      this.showBandTraverPointSelect = true
      this.traver_point_list = []
      this.getTraverPointFromDest(this.formResidenceInfo.residence_id)
    },
    // 获取 当前酒店的目的目的地
    getTraverPointFromDest(residence_id) {
      this.$http
        .get(`/traver/residence_id_get_dest?residence_id=${residence_id}`)
        .then((res) => {
          console.log(res)
          if (res.data.errno == '0') {
            // 根据目的地信息获取 周边 迹点 数据
            this.getTraverPointList(res.data.dest)

            // this.destShowBack = res.data.dest
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    //  搜索迹点
    searchButton(item) {
      this.page = 1
      this.traver_point_list = []
      this.key_word = item.key_word
      this.getTraverPointList(item.dest)
    },
    // 下一页迹点
    loadMorTraverPointer(item) {
      this.page += 1
      this.key_word = item.key_word
      this.getTraverPointList(item.dest)
    },
    // 获取 迹点列表
    getTraverPointList(dest_id) {
      this.$http
        .get(
          `/traver/get_traver_point_list?source_map=2&traver_title=${this.key_word}&dest=${dest_id}&traver_class=${this.traver_class}&p_num=${this.page}&p_size=${this.pagesize}`
        )
        .then((res) => {
          // console.log('搜索迹点列表：', res)
          if (res.data.errno == '0') {
            let list = res.data.data
            list.forEach((i) => {
              if (i.poi_id !== null) {
                let item = {
                  id: i.id,
                  title: i.traver_title,
                  title_mini: i.traver_info,
                  image: i.traver_cover,
                  corner_name: i.traver_class,
                  class_name: i.traver_class,
                  lng: parseFloat(i.poi_lng),
                  lat: parseFloat(i.poi_lat),
                }
                this.traver_point_list.push(item)
              }
            })
            // console.log(this.traver_point_list)
            this.$refs.showLocationOnMap.pointerOnMap()
          }
        })
    },
  },
}
</script>

<style>
.page-header-button {
  /* background-color: red; */
  font-size: 15px;
}
.el-card.card-header-style .el-card__header {
  background-color: #ff5421;
  color: white;
  padding: 5px 10px;
}
.header-product-title {
  padding: 5px;
}
.recommand_traver_of_residence {
  border: 1px solid #ff5421;
  padding: 10px;
  margin: 10px 0;
}
</style>